// extracted by mini-css-extract-plugin
module.exports = {"AppRoundedButton":"styles_AppRoundedButton___CKpI","small":"styles_small__J_aNy","AppLoadingButton":"styles_AppLoadingButton__sDeY_"};